var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "top3", staticClass: "slider-item slider-item--top3" },
    [
      _c("h2", {
        ref: "title",
        staticClass: "slider-item__title",
        domProps: { innerHTML: _vm._s(_vm.title) }
      }),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "top3-list" },
        _vm._l(_vm.list, function(item) {
          return _c("li", { key: item.name, staticClass: "top3-list__item" }, [
            _c("div", { staticClass: "top3-list__item-wrapper" }, [
              _c("div", { staticClass: "top3-list__item-container" }, [
                _c("strong", [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t.__("common.labels.with")) +
                    "\n                    "
                ),
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(item.value) +
                      " " +
                      _vm._s(_vm.getUnit(item)) +
                      " "
                  )
                ])
              ])
            ])
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }